import React from "react";
import Modal from "../../components/Modal";

const RulesModal = ({ isOpen, setIsOpen }) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            modalTitle=""
        >
            <div className="row">
                <div className="col-xl-12 rules-con">

                    <div className="rules-image" />

                    <div className="rules-text" style={{ marginTop: 140 }}>

                        <h5 className="text-center fw-bold">
                            قوانین، مقررات و شرایط استفاده از سامانه کارسود
                        </h5>

                        <h6 className="text-center">
                            تابع قوانین جمهوری اسلامی ایران
                        </h6>

                        <h6 className="text-center mb-4">
                            کاربر گرامی لطفاً پیش از ثبت نام موارد زیر را با دقت مطالعه فرمایید
                        </h6>

                        <p>
                            کاربر گرامی خواهشمند است پیش از ثبت‌نام، تمامی موارد و شرایط استفاده از کارسود را با دقت مطالعه نمایید تا فرایند همکاری بر پایه آگاهی کامل و مسئولیت مشترک صورت گیرد.
                        </p>

                        <hr />

                        <h6 className="fw-bold mt-3">
                            📚 بند ۱: پذیرش قوانین و مقررات و الزامات کاربری
                        </h6>

                        <p>
                            ۱-۱. الزام به مطالعه و پذیرش: بر اساس قوانین تجارت الکترونیک، با ثبت نام در سامانه کارسود شما موافقت خود را با کلیه قوانین، مقررات و شرایط شرکت بی همتا تجارت مدرن اعلام می‌نمایید
                            ثبت‌نام کاربر در سامانه‌ی کارسود، مستلزم مطالعه‌ی دقیق و پذیرش کامل و بی‌قید و شرط تمامی قوانین، مقررات، شرایط استفاده و ضوابط ابلاغی شرکت «بی همتا تجارت مدرن» (مالک سامانه) است که مطابق با مقررات تجارت الکترونیک تدوین شده‌اند.
                        </p>

                        <p>
                            ۱-۲. تعهد به اجرا: این اقدام (ثبت‌نام) به منزله‌ی آگاهی کامل کاربر از تمامی ضوابط و تعهدات مندرج در این مقررات است و الزام قانونی به رعایت و اجرای کامل تمامی مفاد را برای وی ایجاد می‌نماید.

                        </p>

                        <p>
                            ۱-۳. ضمانت اجرا و سلب حق اعتراض: در صورت تخلف، تخطی، عدم رعایت یا نقض هر یک از قوانین و مقررات این سامانه و قرارداد، «کارسود» مجاز است مطابق ضوابط و مقررات داخلی خود و مفاد قانونی قرارداد، اقدامات مقتضی را به عمل آورد. این اقدامات می‌تواند شامل مسدودسازی یا غیرفعال نمودن حساب کاربری کاربر خاطی و پیگیری قانونی در مراجع ذی‌صلاح، بدون نیاز به اطلاع یا هماهنگی قبلی باشد. در این صورت، کاربر خاطی حق هیچ‌گونه اعتراض، شکایت، ادعا یا مطالبه‌ای در خصوص اقدام صورت‌گرفته نخواهد داشت.
                        </p>

                        <h6 className="fw-bold mt-4">
                            📚 بند ۲: ثبت‌نام و پرداخت‌های مالی
                        </h6>

                        <p>
                            ۲-۱. ثبت‌نام در سامانه‌ی کارسود کاملاً رایگان است. طرف دوم (کاربر) تحت هیچ عنوانی مجاز به پرداخت هرگونه وجه، هزینه یا کارمزد بابت فرآیند ثبت‌نام به اشخاص ثالث یا نمایندگان مدعی نخواهد بود.
                        </p>

                        <p>
                            ۲-۲. کلیه‌ی تراکنش‌ها و پرداخت‌های مالی که در راستای فعالیت‌های موضوع این قرارداد و استفاده از خدمات کارسود انجام می‌شوند، منحصراً از طریق درگاه‌ها و سازوکارهای رسمی و داخلی سامانه‌ی کارسود صورت می‌پذیرد.
                        </p>

                        <p>
                            ۲-۳. مسئولیت واریز وجه در خارج از بستر رسمی کارسود: هرگونه پرداخت یا واریز وجه به اشخاص حقیقی یا حقوقی خارج از سامانه‌ی کارسود، به هر دلیلی، به منزله‌ی اقدام شخصی و خارج از تعهدات کارسود تلقی می‌شود و کارسود هیچ‌گونه مسئولیت حقوقی، مالی یا کیفری در قبال خسارات یا کلاهبرداری‌های احتمالی ناشی از این پرداخت‌ها نخواهد پذیرفت.
                        </p>

                        <h6 className="fw-bold mt-4">
                            📚 بند ۳: طرح‌ها، خدمات و امکان کسب درآمد در کارسود
                        </h6>

                        <p>
                            ۳-۱. علاوه بر طرح‌ها، خدمات، محصولات و امکانات موجود، به‌صورت مستمر طرح‌ها و خدمات جدیدی به سامانه‌ی کارسود افزوده می‌شود تا بتواند بخش عمده‌ای از نیازهای روزمره کاربران را برطرف نماید.
                        </p>

                        <p>
                            ۳-۲. سامانه‌ی کارسود این امکان را برای کاربران فراهم نموده است تا در صورت تمایل، در بخش «کسب درآمد» فعالیت نموده و از طریق انجام فعالیت‌های مجاز، درآمد نقدی کسب نمایند.
                        </p>

                        <p>
                            ۳-۳. کاربران می‌توانند درآمد حاصل از فعالیت خود را به دو صورت مورد استفاده قرار دهند:
                            ۱. پرداخت هزینه‌ی طرح‌ها، خدمات و محصولات موجود در کارسود از محل درآمد به‌دست‌آمده.
                            ۲. انتقال یا واریز وجه به حساب بانکی شخصی کاربر از طریق بخش تسویه‌حساب سامانه.
                            <br />
                            برای فعال‌سازی امکان کسب درآمد و همچنین جهت برداشت کلیه درآمدهای کسب شده از کارسود، تکمیل فرآیند احراز هویت و ثبت اطلاعات بانکی الزامی است.
                            <br />
                            در صورت عدم تکمیل این فرآیند، امکان کسب درآمد برای شما در کارسود متوقف و یا به حداقل خواهد رسید.
                            <br />
                            توجه: استفاده، خرید و بهره‌مندی از محصولات، خدمات و طرح‌های موجود، بدون نیاز به احراز هویت امکان‌پذیر است؛ اما برای کسب درآمد، امور مالی و تسویه‌حساب، شرط اول، احراز هویت و ثبت اطلاعات بانکی می باشد وکاملاً ضروری است
                        </p>

                        <h6 className="fw-bold mt-4">
                            📚 بند ۴: طرح‌های درآمدی و شرایط استفاده
                        </h6>

                        <p>
                            ۴-۱. در سامانه‌ی کارسود، مجموعه‌ای از طرح‌های درآمدی طراحی شده است که کاربران می‌توانند در صورت تمایل، بخشی از درآمد خود را برای فعال‌سازی این طرح‌ها اختصاص دهند. همچنین، امکان فعال‌سازی طرح‌ها از طریق حساب بانکی شخصی کاربر نیز فراهم می‌باشد.
                        </p>

                        <p>
                            ۴-۲ . میزان درآمد کسب‌شده از این طرح‌ها به‌طور مستقیم متناسب با میزان فعالیت، مشارکت و عملکرد کاربر می‌باشد.
                            <br />
                            لازم به ذکر است که روند رشد درآمد همواره صعودی و یکنواخت نخواهد بود و ممکن است براساس عواملی مانند سطح فعالیت کاربر، میزان درآمدهای کسب‌شده توسط کارسود، وضعیت کلی طرح و سایر متغیرهای موثر، دچار نوسان و تغییر (کاهش یا افزایش) گردد؛ حتی در برخی موارد ممکن است روند درآمد برای مدتی متوقف گردد
                            <br />
                            نکته کلیدی: با حفظ فعالیت مستمر، پایبندی، پیروی و عمل به آموزش‌های ارائه شده و ارتقاء سطح عملکرد، پتانسیل قابل توجهی برای رشد پیوسته و پایدار درآمد هر کاربر فراهم است و در بلندمدت، می‌توان انتظار داشت که برآیند کلی درآمد کاربر همواره در حال افزایش باشد.
                            <br />
                            نتیجه نهایی: انتظار رشد مداوم و نامحدود درآمد، یا برعکس، کاهش و توقف دائمی آن، تصوری نادرست است. نمودار درآمد در طرح‌های «کارسود» که شامل افزایش، کاهش و دوره‌های توقف می‌شود، کاملاً طبیعی و قابل انتظار است. این نوسانات تابعی از عوامل متعددی است که بر عملکرد کلی طرح تأثیر می‌گذارند.
                        </p>

                        <p>
                            ⚠️ ۴-۳. فعال‌سازی طرح‌های درآمدی کاملاً اختیاری است. کاربران هیچ‌گونه الزام یا تعهدی برای مشارکت در این طرح‌ها ندارند و می‌توانند در صورت تمایل، اقدام به فعال‌سازی آن‌ها نمایند. همچنین، کاربران مجازند از طرح‌های درآمدی سایر کسب‌وکارهای همکار با کارسود که دارای قرارداد همکاری رسمی هستند نیز بهره‌مند شوند.
                        </p>

                        <p>
                            ⚠️ ۴-۴. نکات مهم و الزامات پیش از فعال‌سازی یا خرید:
                            قبل از اقدام به خرید هر نوع محصول، خدمت یا طرح درآمدی، ضروری است کاربر قوانین و مقررات مربوطه، راهنماها و محتوای آموزشی ارائه‌شده در کانال‌های رسمی کارسود را به‌طور کامل مطالعه و از شرایط و نحوه‌ی کسب درآمد اطلاع دقیق حاصل نماید.
                            <br />
                            لازم به ذکر است تنها مرجع رسمی و مورد تأیید جهت دسترسی به اطلاعات، آموزش‌ها و اطلاعیه‌های معتبر، وب‌سایت کارسود و نهادهای یا مراجعی هستند که به‌صورت رسمی از طریق این وب‌سایت معرفی شده‌اند.
                            هرگونه تبلیغ، اطلاع‌رسانی، معرفی خدمات یا آموزش‌ها که خارج از بسترها، سامانه‌ها و کانال‌های رسمی اعلام‌شده توسط کارسود انجام گیرد، فاقد اعتبار است.
                            <br />
                            کارسود هیچ‌گونه مسئولیتی در قبال محتوا، تبلیغات یا اطلاع‌رسانی‌های نادرست، دروغین، گمراه‌کننده یا خلاف‌واقع که توسط اشخاص حقیقی یا حقوقی، صفحات شبکه‌های اجتماعی، وب‌سایت‌ها یا سایر بسترهای غیررسمی منتشر گردد، نخواهد داشت.
                            <br />
                            همچنین کاربران موظف‌اند اطلاعات و محتوای موردنیاز خود را صرفاً از منابع رسمی معرفی‌شده توسط کارسود دریافت نمایند. استفاده از منابع غیررسمی، مسئولیتی برای کارسود ایجاد نخواهد کرد.
                        </p>

                        <p>
                            ⚠️ ۴-۵. غیرقابل‌استرداد بودن وجوه پرداختی:
                            وجوه پرداخت‌شده بابت فعال‌سازی هر نوع طرح درآمدی، محصول یا خدمت در سامانه، به هیچ عنوان قابل بازگشت نمی‌باشد. لذا توصیه می‌شود کاربران با دقت کامل و پس از بررسی همه‌جانبه, نسبت به پرداخت وجه و فعال‌سازی طرح اقدام نمایند.                        
                        </p>

                        <p>
                            نکته بسیار مهم:
                        </p>

                        <p>
                            لازم به ذکر است که کلیه «طرح‌های درآمدی» به عنوان یک آپشن تکمیلی و هدیه مازاد در نظر گرفته شده‌اند. این مزایا پس از خرید محصولات یا خدمات از کارسود، برای کاربر فعال می‌گردند.
                            با خرید هرگونه محصول یا خدمت، تسویه حساب کامل میان کاربر و مجموعه کارسود صورت می‌گیرد. در واقع، مبلغ پرداختی شما در قبال دریافت محصول/خدمت است.

                            استفاده از آپشن‌های درآمدی، یک «فرصت» است. کسب درآمد از این بخش، کاملاً وابسته به فعالیت مستقیم، مستمر و بلندمدت کاربر است. در صورتی که کاربر تمایلی به فعالیت در این بخش نداشته باشد، صرفاً از محصول و خدمات خریداری شده بهره‌مند خواهد بود.

                            با توجه به اینکه این آپشن یک هدیه است و نتیجه آن مستقیماً به تلاش کاربر بستگی دارد، مجموعه کارسود هیچ‌گونه مسئولیتی در قبال میزان درآمد یا عدم کسب درآمد کاربر نخواهد داشت.

                            مهم‌ترین ابزار کسب درآمد در این سیستم، «معرفی کارسود به دیگران» است. تمامی راهنمایی‌ها و استراتژی‌های لازم برای موفقیت در این مسیر، در کانال‌های آموزشی ما به طور کامل درج شده است.
                        </p>

                        <h6 className="fw-bold mt-4">
                            📚 بند ۵: ضوابط رفتار و انتشار محتوا توسط کاربران
                        </h6>

                        <p>
                            کاربران سامانه‌ی کارسود موظف‌اند در تمامی فضاهای مجازی و حقیقی، از جمله کانال‌ها، گروه‌ها، صفحات شبکه‌های اجتماعی، تماس تلفنی، پیامک، ارتباط حضوری و سایر شیوه‌های ارتباطی، صرفاً در چارچوب فعالیت‌های مجاز کارسود اقدام نمایند.
                        </p>

                        <p>
                            تحت هیچ شرایطی، کاربران حق تبلیغ، معرفی یا ترویج هرگونه پلتفرم، کسب‌وکار یا خدمت دیگر را که خارج از بستر رسمی کارسود باشد، ندارند.
                        </p>

                        <p>
                            همچنین انتشار، بازنشر یا تولید هر نوع محتوای غیراخلاقی، خلاف واقع، گمراه‌کننده، دارای جنبه‌های کلاهبرداری یا مغایر با قوانین و مقررات جمهوری اسلامی ایران، اکیداً ممنوع است.
                        </p>

                        <h6 className="fw-bold mt-4">
                            📚 بند ۶: احترام متقابل و رفتار حرفه‌ای کاربران
                        </h6>

                        <p>
                            کاربران سامانه‌ی کارسود موظف‌اند در تمامی تعاملات خود اصول احترام، ادب و رفتار حرفه‌ای را به‌طور کامل رعایت نمایند، هرگونه مزاحمت، تهدید، افترا، تهمت، توهین، بی‌احترامی یا رفتار مغایر با شأن اخلاقی و اجتماعی در فضای حقیقی یا مجازی نسبت به کارکنان، نمایندگان، همکاران و سایر کاربران اکیداً ممنوع میباشد
                        </p>

                        <div className="position-relative">

                            {/* بقیه محتوا ... */}

                            <div className="alert alert-danger fw-bold mt-4 rounded-3 shadow-sm p-3">
                                <div>
                                    🚨 در صورت تخطی از هر یک از بندهای فوق، بند ۱ اعمال خواهد شد.
                                </div>
                            </div>

                            {/* دکمه بیرون از کادر و پایین سمت چپ */}
                            <br />
                            <button
                                type="button"
                                className="btn btn-danger fw-bold position-absolute"
                                style={{ bottom: '-2px', left: '0' }}
                                onClick={() => setIsOpen(false)}
                            >
                                متوجه شدم
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default RulesModal;
